import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    buttonDivider:{
        paddingTop:20,
        marginBottom:10,
    },
    buttonBar: {
        marginBottom:20
    },
    nextButton: {
        float: "right",
    },
    finishButton: {
        float: "right",
    },
    backButton: {
        float: "left",
    },
    stepper: {
        marginBottom: "20px",
        marginTop: "20px",
        backgroundColor: "inherit",
    },
}));
